import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import routes from './routes/routes';
import { AuthProvider } from './stores/AuthContext';
// eslint-disable-next-line import/no-unresolved
import 'reguide/style.css';
import './index.css';
import { ToastProvider } from './components/ui/ToastProvider';
import { capturePasswordSetupToken } from './services/passwordSetupToken';
import { syncRouteTheme } from './utils/routeTheme';

const unsubscribeTheme = syncRouteTheme(routes);
if (import.meta.hot) {
  import.meta.hot.dispose(unsubscribeTheme);
}
capturePasswordSetupToken();
if (import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2026-01-30',
    session_recording: {
      recordBody: false,
      recordHeaders: false,
    },
    // Runs before the initial $pageview and overrides any super property persisted by another app
    before_send: (event) =>
      event && {
        ...event,
        properties: { ...event.properties, app: 'dashboard' },
      },
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={routes} />
        </ToastProvider>
      </AuthProvider>
    </PostHogProvider>
  </StrictMode>
);
